import type { SpendSavingsMonth } from "./api";

export function formatCurrency(amount: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function getCompletedMonthsForComparison(months: SpendSavingsMonth[]) {
  if (months.length < 2) return { current: null, previous: null };

  const latest = months[months.length - 1];

  if (latest.is_partial_month) {
    if (months.length < 3) return { current: null, previous: null };
    return {
      current: months[months.length - 2],
      previous: months[months.length - 3],
    };
  }

  return {
    current: months[months.length - 1],
    previous: months[months.length - 2],
  };
}
